
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScreeningOutcomeSummary"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ScreeningOutcomeSummary"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relevantCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"notSureCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"notRelevantCount"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":114}};
    doc.loc.source = {"body":"fragment ScreeningOutcomeSummary on ScreeningOutcomeSummary {\n  relevantCount\n  notSureCount\n  notRelevantCount\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
